module.exports = __webpack_public_path__ + "a5d4fcef9bd12a0c6152293310c9541d.MP3";